import React from 'react'

const Text2 = props => (
  <div className="text2">
    <div className="Text2">{props.Text2}</div>
  </div>
)

export default Text2
